import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  theme?: 'light';
}

export default function HorizontalIcon({ theme: _theme, ...rest }: Props) {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 5696 1080"
      {...rest}
    >
      <switch>
        <g>
          <g>
            <g>
              <g>
                <path
                  fill="#301B6B"
                  d="M1543.7,513.1c-25-28.3-66.6-52.1-124.8-71.1c-8.1-2.6-25.7-8.3-52.9-17c-27.2-8.7-44.3-14.3-51.2-16.9
						c-35-10.7-52.5-33.7-52.5-69c1.2-28.6,10.7-49.1,28.4-61.4c17.8-12.3,44.1-18.5,79.2-18.5c47.4,0,98.6,12.1,153.7,36.3
						c2.3,1,5,0,6-2.4l31-74.9c1.6-3.8,0.1-8.3-3.6-10.2c-54.2-29.2-118.2-43.8-191.9-43.8c-67.7,0-122,15.6-162.9,46.9
						c-41,31.2-61.4,75.7-61.4,133.2c0,82.2,42.6,138.3,127.9,168.4c6.7,2.6,17.6,6.3,32.8,11.1c15.2,4.8,31.4,9.7,48.8,14.7
						c17.3,5.1,27.9,8.2,31.7,9.3c53.2,15.3,79.8,43,79.8,82.9c0,30.1-9.6,53.2-28.6,69.2c-19.1,16.1-47.3,24.1-84.7,24.1
						c-30.3,0-61.5-4.7-93.4-13.9c-30.1-8.8-58.1-20-84-33.9c-2.5-1.3-5.5-0.1-6.4,2.6l-25.1,81.8c-1.1,3.6,0.4,7.6,3.8,9.5
						c59.4,33.1,126.2,49.8,200.5,49.8c72.6,0,130.3-16.3,173.1-48.8c42.8-32.5,64.2-79,64.2-139.5
						C1581.2,580.9,1568.7,541.4,1543.7,513.1z"
                />
                <path
                  fill="#301B6B"
                  d="M2480.6,364.5c-29.2-27.9-75.9-41.9-140.1-41.9c-63.8,0-123.2,11.4-178.2,34.3c-2.3,0.9-3.4,3.5-2.5,5.7
						c2.1,5.7,6.3,17.4,12.8,35.1c6.4,17.7,10.7,29.5,12.8,35.3c0.9,2.3,3.5,3.5,5.8,2.6c55.1-20.6,101.5-31,139.3-31
						c27.3,0,47.5,6.6,60.8,19.8c13.3,13.2,20,34.2,20,63.1v25.2c-7.5,0.9-17.8,1.9-30.8,3.1c-13,1.2-24.7,2.3-35.1,3.4
						c-10.5,1.2-20.1,2.3-29.1,3.5c-65.4,6.3-114.3,21.5-146.7,45.3c-32.4,23.8-48.6,60.5-48.6,110c0,46,13.6,81.3,41,105.6
						c27.4,24.5,63.2,36.7,107.4,36.7c32.3,0,60-5.4,82.6-16.3c22.8-10.8,46-27.8,69.7-50.9c0,1.1,3,10.8,9.1,29
						c4.3,13.1,7.2,21.8,8.6,26.1c0.6,1.9,2.3,3.1,4.3,3.1h76.4c2.5,0,4.5-2,4.5-4.5V500.1C2524.4,437.6,2509.8,392.4,2480.6,364.5z
						 M2410.7,674.9c-8.4,18-22.3,33.2-41.8,45.8c-19.6,12.6-42.5,19-68.8,19c-22,0-38.9-5.5-50.7-16.3
						c-11.9-10.8-17.8-26.4-17.8-46.6c0-29.5,10.7-50.9,32.1-64.3c21.4-13.3,55.2-21.9,101.1-26c1.2,0,8.9-0.5,23.2-1.7
						c14.4-1.2,21.9-1.7,22.8-1.7V674.9z"
                />
                <path
                  fill="#301B6B"
                  d="M2867.6,332.1c-59.3,0.6-104.5,25-135.8,75.1l-14-69.3c-0.4-2.1-2.3-3.6-4.4-3.6h-87.3
						c-2.5,0-4.5,2.1-4.5,4.5v467.9c0,2.5,2,4.5,4.5,4.5h104.6c2.5,0,4.5-2,4.5-4.5V552.5c0-39.7,10.4-70.6,31.1-92.8
						c20.7-22.3,52-33.4,94-33.4c4.8,0,11,0.1,18.1,0.6c1.9,0.1,3.6-1,4.2-2.8l27.9-84c0.8-2.3-0.7-4.9-3.1-5.3
						C2895,332.6,2882.8,331.9,2867.6,332.1z"
                />
                <path
                  fill="#301B6B"
                  d="M3145.3,733.5c-39.9,0-70.8-13.8-92.6-41.6c-21.9-27.8-32.8-68.3-32.8-121.5c0-52.6,11.1-92.7,33.2-120.2
						c22.1-27.4,52.4-41.3,90.9-41.3c32.5,0,67.5,9.5,105.1,28.5c2.5,1.2,5.5,0.1,6.3-2.5l24.1-72.8c0.7-2-0.1-4.3-2-5.4
						c-38-22.7-84.1-34.1-138.4-34.1c-69.7,0-126,21.6-168.6,64.6c-42.7,43.2-64,103.7-64,181.8c0,80.7,20.3,142.7,60.9,186.2
						c40.6,43.3,97.4,65,170.3,65c29.5,0,55-2.9,76.4-8.7c20.5-5.5,40.4-14.5,59.6-27c1.5-1,2.3-2.7,2.1-4.4l-9.6-76.5
						c-0.4-3.2-4-4.9-6.8-3.2C3222.9,722.4,3184.8,733.5,3145.3,733.5z"
                />
                <g>
                  <path
                    fill="#DC7441"
                    d="M4277.3,154.2l0,108.5c0,1.5-1.2,2.7-2.7,2.7c-60.8-1.4-109.7-50.4-111.2-111.2c0-1.5,1.2-2.7,2.7-2.7
							l108.5,0C4276.1,151.5,4277.3,152.7,4277.3,154.2z"
                  />
                  <path
                    fill="#301B6B"
                    d="M4163.3,338.8v467.9c0,2.5,2,4.5,4.5,4.5h104.6c2.5,0,4.5-2,4.5-4.5V338.8c0-2.5-2-4.5-4.5-4.5h-104.6
							C4165.3,334.3,4163.3,336.3,4163.3,338.8z"
                  />
                </g>
                <path
                  fill="#301B6B"
                  d="M5693.3,731.5c-0.1-2.7-2.5-4.6-5.2-4.2c-16.9,2.4-33,3.6-47.9,3.6c-28.1,0-47.3-7.6-57.8-22.9
						c-10.4-15.3-15.6-41.1-15.6-77.3V403.3h113.9c2.5,0,4.5-2,4.5-4.5v-60c0-2.5-2-4.5-4.5-4.5h-113.9V209.1c0-2.5-2-4.5-4.5-4.5
						l-61.5,0.4c-2,0-3.8,1.4-4.3,3.3l-14.3,50.8c-12.7,45.3-52.1,78-99,82.2l0,0c-2.2,0.2-3.9,2-4.1,4.2l-3.7,52.9
						c-0.2,2.6,1.9,4.8,4.5,4.8h73.3v225.2c0,33,2.5,60.7,7.6,83.2c5.1,22.4,13.7,41.8,25.8,58.3c12.2,16.5,29,28.5,50.6,36.2
						c21.6,7.7,48.6,11.6,81,11.6c8,0,16.7-0.5,26-1.4c9.2-0.8,16.8-1.8,22.8-2.8c6-1,12.2-2.2,18.7-3.4c6.5-1.4,10-2,10.7-2
						L5693.3,731.5z"
                />
                <path
                  fill="#301B6B"
                  d="M2020.6,384.2c-36.3-41-87.2-61.6-152.9-61.6c-69.5,0.2-124.3,22.8-164.4,67.7
						c-40.3,44.7-60.4,105.2-60.4,180.9c0,77.8,21.3,138.8,64.1,182.9c42.6,44,102.3,66.1,178.9,66.1c64.8,0,120.6-14.2,167.8-42.6
						c1.7-1,2.5-2.9,2.1-4.8l-14.2-71.5c-0.6-3-3.9-4.5-6.5-3c-46.4,25.2-94.6,37.7-144.8,37.7c-40.8,0-74.3-10.9-96.1-36.6
						c-50.5-59.6-55.5-199,0-265.3c18.3-21.8,44.7-30.3,74-30.3c31.2,0,55.7,10.4,73.3,31.2c17.7,20.8,26.5,50.7,26.5,89.4l-144.9,0
						c-4.2,0-7.9,2.8-8.8,6.9c-2.7,12.2-4.2,25.1-4.2,38.5c0,6.2,0.3,12.3,0.9,18.2c0.5,4.5,4.4,7.9,9,7.9l240.5,0
						c7.9,0,14.3-6.4,14.4-14.3c0-3,0.1-6.3,0.1-10c0.2-11,0.2-19,0.2-24C2075,479.9,2056.9,425.2,2020.6,384.2z"
                />
                <path
                  fill="#301B6B"
                  d="M3780.5,509.1v297.5c0,2.5-2,4.5-4.5,4.5h-104.6c-2.5,0-4.5-2-4.5-4.5v-285c0-39-6.3-67.7-18.7-86
						c-12.5-18.1-33.6-27.2-63.3-27.2c-25.4,0-48,6.4-67.7,19.3c-19.7,12.8-34.4,29.4-44.3,49.7c-6.9,26.6-10.5,61.2-10.5,104.1
						l-0.5,225.1c0,2.5-2,4.5-4.5,4.5h-104.2c-2.5,0-4.5-2-4.5-4.5V156c0-2.5,2-4.5,4.5-4.5h104.1c2.5,0,4.5,2,4.5,4.5l0.2,234.3
						c37.8-45.2,86.5-67.7,150.5-67.7c53.3,0,94.5,15.2,123.9,45.7C3765.8,398.9,3780.5,445.8,3780.5,509.1z"
                />
                <g>
                  <path
                    fill="#301B6B"
                    d="M4093.7,732.5c-0.2-2.3-2.3-4-4.6-3.7c-13.2,1.4-24.5,2.1-34.3,2.1c-29.1,0-48.9-7.6-58.9-22.8
							c-10.1-15.1-15.2-44.1-15.2-87V156c0-2.5-2-4.5-4.5-4.5h-104.6c-2.5,0-4.5,2-4.5,4.5v467.4c0,34.4,2.4,63.2,7.3,86.3
							s13.6,43.1,26.1,59.9c12.4,16.8,29.5,29,50.9,36.6c21.6,7.7,48.6,11.6,81.3,11.6c8.1,0,17-0.6,26.6-1.5
							c9.5-1.1,17.5-2.1,23.6-3.1c4.1-0.7,8.4-1.4,12.8-2.3c2-0.4,3.5-2.3,3.3-4.3L4093.7,732.5z"
                  />
                </g>
                <path
                  fill="#301B6B"
                  d="M5333.3,509.1v297.5c0,2.5-2,4.5-4.5,4.5h-104.6c-2.5,0-4.5-2-4.5-4.5v-285c0-39-6.3-67.7-18.7-86
						c-12.5-18.1-33.6-27.2-63.3-27.2c-25.4,0-48,6.4-67.7,19.3c-19.7,12.8-34.4,29.4-44.3,49.7c-6.9,26.6-10.5,61.2-10.5,104.1
						l-0.5,225.1c0,2.5-2,4.5-4.5,4.5h-104.2c-2.5,0-4.5-2-4.5-4.5V156c0-2.5,2-4.5,4.5-4.5h104.1c2.5,0,4.5,2,4.5,4.5l0.2,234.3
						c37.8-45.2,86.5-67.7,150.5-67.7c53.3,0,94.5,15.2,123.9,45.7C5318.6,398.9,5333.3,445.8,5333.3,509.1z"
                />
              </g>
              <path
                fill="#301B6B"
                d="M4842.7,334.9c-12.3-2.3-24.5-2.9-39.7-2.8c-38.2,0.5-70.5,10.9-97,31.5c-35.5-25.8-80.6-39-135.8-39
					c-69.5,0-123.3,18.7-161.4,56.2c-38.1,37.4-57.2,88.6-57.2,153.5c0,62.9,19.1,113.7,57.2,152.2c10,10.1,21,18.8,33,26.3
					l-12.4,8.1l-0.1,0.1c-35.1,22.7-57.1,42.6-56.8,75.7c0.7,107.2,186.1,94.1,243.5,93.8c57.4-0.3,75.8,11.3,75.8,49.3
					c0,40.7-34.1,66.3-135.5,66.3c-84.4,0-115.6-18.9-115.6-55c0-9.4,1.7-17.5,4.8-24.6c1.1-2.5-0.2-5.4-2.8-6.2
					c-7.2-2.2-15.6-5-25.3-8.5c-0.8-0.3-1.5-0.6-2.3-0.8c-39.2-14.5-82,13.5-82.4,55.3c0,0.3,0,0.6,0,1c0,69.1,73,112.8,225.6,112.8
					c171.5,0,245.4-67.3,245.4-158.3c0-90-65.4-123.1-158.2-123.1h-134.5c-30.3,0-43.6-8.6-43.6-32.3c0-12.3,6.6-15.1,18-24.6
					c0.1,0,5.4-3.9,8.8-6.3c21.7,5.9,45.5,9,71.6,9c69.2,0,123-19,161.4-56.9c38.4-37.9,57.6-89,57.6-153.1
					c0-40.1-7.6-75.1-22.8-105c10.4-1.9,21.6-2.9,33.7-2.9c4.8,0,11,0.1,18,0.6c1.9,0.1,3.6-1,4.2-2.8l27.9-84
					C4846.6,337.8,4845.2,335.3,4842.7,334.9z M4646.2,628.9c-17.3,22-43.2,33-77.7,33c-34.7,0-60.8-11-78.4-33
					c-17.6-22-26.4-53.4-26.4-94.3c0-41.5,8.7-73.2,26.2-95.1c17.5-21.9,43.4-32.9,77.9-32.9c34.9,0,61.1,10.9,78.4,32.7
					c17.3,21.8,26,53.4,26,95C4672.3,575.4,4663.6,606.9,4646.2,628.9z"
              />
            </g>
            <g>
              <g>
                <path
                  fill="#DC7441"
                  d="M631.8,6.4l0,254.7c0,3.5-2.9,6.4-6.4,6.4C482.8,264,367.8,149.1,364.5,6.5C364.4,3,367.3,0,370.8,0
						l254.7,0C629,0,631.8,2.9,631.8,6.4z"
                />
                <g>
                  <g>
                    <path
                      fill="#301B6B"
                      d="M13.8,977.7l0-306.3c0-3.6,2.9-6.4,6.5-6.3c171.1,3.4,309.1,141.5,312.5,312.5c0.1,3.6-2.8,6.5-6.3,6.5
								l-306.3,0C16.6,984,13.8,981.2,13.8,977.7z"
                    />
                  </g>
                </g>
              </g>
              <g>
                <path
                  fill="#301B6B"
                  d="M684.6,722.5c-0.5-1.4-1.1-2.7-1.6-4.1c-148.4-0.2-286.4-45.3-400.9-122.4
						C403.4,680,483.3,819.6,485.3,977.9c0,3.4,2.9,6.2,6.3,6.2h14.4C641.1,984,733.7,848.3,684.6,722.5z"
                />
                <path
                  fill="#DC7441"
                  d="M212.1,6.2C212,2.8,209.2,0,205.8,0l-13.8,0C56.9,0-35.9,135.9,13.4,261.6c0.3,0.8,0.6,1.6,1,2.5
						c148.7,0.2,286.9,45.5,401.6,122.9C294.7,303.2,214.6,164.1,212.1,6.2z"
                />
                <path
                  fill="#A342A8"
                  d="M416,386.9C301.3,309.5,163.1,264.2,14.4,264c54,135.8,148.1,251.3,267.7,331.9
						C396.6,673.1,534.5,718.2,683,718.4C629.1,582.8,535.3,467.5,416,386.9z"
                />
              </g>
            </g>
          </g>
        </g>
      </switch>
    </svg>
  );
}
